/*
 *
 * ClinicianToDos constants
 *
 */

export const DEFAULT_ACTION = 'src/ClinicianToDos/DEFAULT_ACTION';
